export default __webpack_public_path__ + "static/media/arrow-up-gray.5599e831.svg";